import(/* webpackMode: "eager" */ "/app/frontend-next/src/app/_ui/components/core/Link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoStatic"] */ "/app/frontend-next/src/app/_ui/components/core/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CCPAOptOut"] */ "/app/frontend-next/src/app/_ui/components/navigation/footer/CCPAOptOut.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieSettings"] */ "/app/frontend-next/src/app/_ui/components/navigation/footer/CookieSettings.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterCollapsibleItem"] */ "/app/frontend-next/src/app/_ui/components/navigation/footer/FooterCollapsibleItem.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSelectorTrigger","LanguageSelector"] */ "/app/frontend-next/src/app/_ui/components/navigation/footer/LanguageSelector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageFooterProvider"] */ "/app/frontend-next/src/app/_ui/components/navigation/footer/PageFooterContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.8.3_@swc+helpers@0.5.19_next@16.2.6_patch_hash=c5541455e773de1062085fcfbcf1_630af0082986833ac5edc01cbcc69602/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
